import { render, staticRenderFns } from "./OrganisationAdmin.vue?vue&type=template&id=237368eb&scoped=true"
import script from "./OrganisationAdmin.vue?vue&type=script&lang=js"
export * from "./OrganisationAdmin.vue?vue&type=script&lang=js"
import style0 from "./OrganisationAdmin.vue?vue&type=style&index=0&id=237368eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237368eb",
  null
  
)

export default component.exports